(() => {
  const variantContainers = [
    '[data-fsm-product-variant-data]',
    '[data-fsm-product-delivery]'
  ].join(', ');

  const selectedVariantId = (productPage, preferredVariantId = null) => {
    if (preferredVariantId) return String(preferredVariantId);

    const form = productPage?.querySelector('form[action*="/cart/add"]:not(.product-form-installment)');
    return form?.querySelector('[name="id"]')?.value || null;
  };

  const updateVariantContent = (productPage, preferredVariantId = null) => {
    const variantId = selectedVariantId(productPage, preferredVariantId);
    if (!variantId) return;

    document.querySelectorAll(variantContainers).forEach((container) => {
      container.querySelectorAll('[data-fsm-variant-id]').forEach((item) => {
        item.hidden = item.dataset.fsmVariantId !== variantId;
      });
    });

    document.querySelectorAll('[data-fsm-variant-row]').forEach((row) => {
      const selected = row.dataset.fsmVariantRow === variantId;
      const link = row.matches('a') ? row : row.querySelector('a');
      row.classList.toggle('is-selected', selected);
      if (selected) link?.setAttribute('aria-current', 'page');
      else link?.removeAttribute('aria-current');
    });

    const delivery = productPage.querySelector(
      `[data-fsm-product-delivery] [data-fsm-variant-id="${CSS.escape(variantId)}"]`
    );
    const addButton = productPage.querySelector('[data-js-product-add-to-cart]');
    const addButtonText = addButton?.querySelector('[data-js-product-add-to-cart-text]');
    if (delivery && addButton && addButtonText) {
      const unavailable = delivery.dataset.fsmDeliveryState === 'unavailable';
      addButton.classList.toggle('disabled', unavailable);
      addButton.disabled = unavailable;
      const expectedLabel = unavailable ? 'Derzeit nicht verfügbar' : 'In den Warenkorb';
      if (addButtonText.textContent.trim() !== expectedLabel) addButtonText.textContent = expectedLabel;

      productPage.querySelectorAll('.fsm-native-express-checkout, .fsm-more-payments').forEach((element) => {
        element.hidden = unavailable;
      });
    }
  };

  const enhanceProductPage = (productPage) => {
    if (!productPage) return;

    const delivery = productPage.querySelector('[data-fsm-product-delivery]');
    const fitCheck = productPage.querySelector('.fsm-fit-check');
    delivery?.closest('.card-widget')?.classList.add('fsm-block--delivery');
    fitCheck?.closest('.card-widget')?.classList.add('fsm-block--fit-check');

    productPage.querySelectorAll('.product-variant').forEach((optionGroup) => {
      const items = optionGroup.querySelectorAll('.product-variant__item');
      if (items.length <= 1) {
        optionGroup.hidden = true;
        optionGroup.dataset.fsmSingleOption = '';
      }

      const optionName = optionGroup.querySelector('.product-variant__name')?.textContent || '';
      if (/ETRTO/i.test(optionName)) {
        optionGroup.querySelectorAll('.product-variant__input').forEach((input) => {
          const label = optionGroup.querySelector(`label[for="${CSS.escape(input.id)}"]`);
          const conciseValue = input.value.match(/^\d{2,3}-\d{3}/)?.[0];
          if (label && conciseValue) {
            label.title = input.value;
            if (label.textContent.trim() !== conciseValue) label.textContent = conciseValue;
          }
        });
      }
    });

    updateVariantContent(productPage);
  };

  const enhanceVariantFilters = () => {
    document.querySelectorAll('[data-fsm-variant-filter]').forEach((input) => {
      if (input.dataset.fsmReady) return;
      input.dataset.fsmReady = 'true';
      input.addEventListener('input', () => {
        const query = input.value.trim().toLocaleLowerCase('de');
        input.closest('[data-fsm-variant-table]')
          ?.querySelectorAll('[data-fsm-variant-row]')
          .forEach((row) => {
            row.hidden = query !== '' && !row.textContent.toLocaleLowerCase('de').includes(query);
          });
      });
    });
  };

  const enhanceAll = () => {
    document.querySelectorAll('.main-product').forEach(enhanceProductPage);
    enhanceVariantFilters();
  };

  document.addEventListener('change', (event) => {
    const productPage = event.target.closest('.main-product');
    if (!productPage) return;

    const preferredVariantId = event.target.dataset.variantId || null;
    window.setTimeout(() => {
      updateVariantContent(productPage, preferredVariantId);
    }, 0);
    window.setTimeout(() => updateVariantContent(productPage), 180);
  });

  document.addEventListener('krown:variant:change', (event) => {
    const productPage = event.detail?.productForm?.closest('.main-product')
      || document.querySelector('.main-product');
    const variantId = event.detail?.variant?.id || null;
    if (!productPage || !variantId) return;

    updateVariantContent(productPage, variantId);
  });

  document.addEventListener('shopify:section:load', enhanceAll);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll, { once: true });
  } else {
    enhanceAll();
  }
})();
